import { MarketPeriods } from "app/utils/const";
import cx from "classnames";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import * as positionMatrixApi from "../../api/positionMatrixApi";
import CurrencyNumber from "../../components/CurrencyNumber/CurrencyNumber";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SegmentedControl from "../../components/SegmentedControl/SegmentedControl";
import { EventHelper } from "../../helpers/eventHelper";
import type { EventType } from "../../types/eventType";
import type { PositionMatrixType } from "../../types/positionMatrixType";
import { IconArrowUp } from "../Icon/Icon";
import "./PositionMatrix.scss";

type Props = {
  positionMatrices: any;
  event: EventType;
  isPositionMatrixLoading?: boolean;
  betDrawerScreen?: boolean;
  onClickExpand?: (...args: Array<any>) => any;
  subscribeEvent: (...args: Array<any>) => any;
  unsubscribeEvent: (...args: Array<any>) => any;
  isIdle: boolean;
};
type State = {
  tab: string;
  positionMatrix: any;
};
export const TabTypes = {
  FULLEVENT: MarketPeriods.FULL_EVENT,
  FIRSTHALF: MarketPeriods.FIRST_HALF,
}; //

class PositionMatrix extends Component<Props, State> {
  intervalId: any;

  constructor(props: any) {
    super(props);
    this.state = {
      tab:
        this.props.positionMatrices && this.props.positionMatrices[0]
          ? this.props.positionMatrices[0].period
          : MarketPeriods.FULL_EVENT,
      positionMatrix: null,
    };
    this.startIntervalFetch();
  }

  componentDidMount() {
    if (this.props.event && EventHelper.isEventLive(this.props.event)) {
      this.props.subscribeEvent(this.props.event.id);
    }
  }

  componentWillUnmount() {
    if (this.props.event && EventHelper.isEventLive(this.props.event)) {
      this.props.unsubscribeEvent(this.props.event.id);
    }

    this.endIntervalFetch();
  }

  renderScores = (axis: string, positionMatrix: PositionMatrixType) => {
    const isEventLive =
      this.props.event && EventHelper.isEventLive(this.props.event);
    let scores = null;

    if (axis === "X") {
      let minScore = positionMatrix.homeRangeMin;
      scores = (
        <React.Fragment>
          <span className={isEventLive ? "scoreDetails" : ""}>{minScore}</span>
          <span>{minScore + 1}</span>
          <span>{minScore + 2}</span>
          <span>{minScore + 3}</span>
          <span>{minScore + 4}</span>
        </React.Fragment>
      );
    } else if (axis === "Y") {
      let minScore = positionMatrix.awayRangeMin;
      scores = (
        <React.Fragment>
          <span className={isEventLive ? "scoreDetails" : ""}>{minScore}</span>
          <span>{minScore + 1}</span>
          <span>{minScore + 2}</span>
          <span>{minScore + 3}</span>
          <span>{minScore + 4}</span>
        </React.Fragment>
      );
    }

    return scores;
  };
  setPositionMatrixData = (period: string) => {
    if (this.props.positionMatrices[0]?.eventId) {
      positionMatrixApi
        .fetchPositionMatrix(this.props.positionMatrices[0]?.eventId, period)
        .then(resp => {
          if (resp.data.positionMatrices) {
            this.setState({
              positionMatrix: resp.data.positionMatrices[0],
              tab: resp.data.positionMatrices[0].period,
            });
          }
        });
    }
  };
  setTab = (tabType: string) => {
    if (this.state.tab === tabType) {
      return null;
    }

    this.setPositionMatrixData(tabType);
    this.setState({
      tab: tabType,
    });
  };
  startIntervalFetch = () => {
    this.setPositionMatrixData(this.state.tab);
    this.intervalId = setInterval(() => {
      if (!this.props.isIdle) {
        this.setPositionMatrixData(this.state.tab);
      }
    }, 15000);
  };
  endIntervalFetch = () => {
    clearInterval(this.intervalId);
  };
  getTabs = () => {
    return [
      {
        title: <FormattedMessage tagName="span" id="bet-betslip-full-time" />,
        callback: () => this.setTab(TabTypes.FULLEVENT),
        isActive: this.state.tab === TabTypes.FULLEVENT,
      },
      {
        title: (
          <FormattedMessage tagName="span" id="drawerincidents-half time" />
        ),
        callback: () => this.setTab(TabTypes.FIRSTHALF),
        isActive: this.state.tab === TabTypes.FIRSTHALF,
      },
    ];
  };

  render() {
    const {
      event,
      isPositionMatrixLoading,
      betDrawerScreen,
      onClickExpand,
      positionMatrices,
    } = this.props;
    const isEventLive =
      this.props.event && EventHelper.isEventLive(this.props.event);
    let positionMatrix = positionMatrices ? positionMatrices[0] : null;

    // Period changes are handled by setting a matrix in state, so use that if it exists
    if (this.state.positionMatrix) {
      positionMatrix = this.state.positionMatrix;
    }

    let xTeam = "XTeam";
    let yTeam = "YTeam";

    if (positionMatrix && positionMatrix.participant1) {
      xTeam = positionMatrix.participant1;
      yTeam = positionMatrix.participant2;
    } else if (event && event.participant1) {
      xTeam = event.participant1;
      yTeam = event.participant2;
    }

    return (
      <div
        className={
          betDrawerScreen ? "position-matrix--bet-drawer" : "position-matrix"
        }
      >
        <div
          className={
            betDrawerScreen
              ? "position-matrix--bet-drawer__header"
              : "position-matrix__header"
          }
        >
          <SegmentedControl tabs={this.getTabs()} tabTypes={TabTypes} />
          {betDrawerScreen && (
            <div className="modal-button" onClick={onClickExpand}>
              <div className="modal-button__inner">
                <IconArrowUp />
              </div>
            </div>
          )}
        </div>
        <div
          className={
            betDrawerScreen
              ? "position-matrix--bet-drawer__content"
              : "position-matrix__content"
          }
        >
          {!isPositionMatrixLoading &&
          positionMatrix &&
          positionMatrix.positions ? (
            <React.Fragment>
              <div
                className={
                  betDrawerScreen
                    ? "position-matrix--bet-drawer__content__x-team"
                    : "position-matrix__content__x-team"
                }
              >
                <div className="x-team-name">{xTeam}</div>
                <div className="x-team-scores">
                  {this.renderScores("X", positionMatrix)}
                </div>
              </div>
              <div
                className={
                  betDrawerScreen
                    ? "position-matrix--bet-drawer__content__main-row"
                    : "position-matrix__content__main-row"
                }
              >
                <div
                  className={
                    betDrawerScreen
                      ? "position-matrix--bet-drawer__content__y-team"
                      : "position-matrix__content__y-team"
                  }
                >
                  <div className="y-team-name">
                    <div>{yTeam}</div>
                  </div>
                  <div className="y-team-scores">
                    {this.renderScores("Y", positionMatrix)}
                  </div>
                </div>
                <div
                  className={
                    betDrawerScreen
                      ? "position-matrix--bet-drawer__content__grid"
                      : "position-matrix__content__grid"
                  }
                >
                  {positionMatrix.positions.map((position, index) => {
                    return (
                      <div
                        key={`pm_${index}`} // Check for larger numbers so they can fit
                        className={cx("grid-cell", {
                          "grid-cell--negative": position.amount < 0,
                          "grid-cell--positive": position.amount >= 0,
                          "current-amount": index === 0 && isEventLive,
                        })}
                      >
                        <CurrencyNumber
                          value={position.amount}
                          hideDecimalIfZeros={true}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isIdle: state.sessionModel.isIdle,
});

function mapDispatchToProps(dispatch) {
  return {
    subscribeEvent: (eventId: number) =>
      dispatch.subscribeModel.subscribeEvent({
        eventId,
      }),
    unsubscribeEvent: (eventId: number) =>
      dispatch.subscribeModel.unsubscribeEvent({
        eventId,
      }),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionMatrix) as any;
